import environmentHelper from "src/share/utils/environmentHelper";
import * as firebase from "firebase/app";
import "firebase/performance";
firebase.initializeApp(environmentHelper.getFirebase())
firebase.performance();
// perf.trace()



// WEBPACK FOOTER //
// ./src/share/config/firebase.ts